import {AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {emailMatcherValidator, emailValidado} from "./novo-parceiro.model";

export class AceiteTermos {
  parceiroId: string;
  declaroSerRepresentanteLegal;
  tipoTermo: string;
  ipDispositivo: string;
  nome: string;
  documento: string;
  form: FormGroup;

  constructor(other?: any) {
    if (other) {
      this.parceiroId = other.parceiroId;
      this.tipoTermo = other.tipoTermo;
      this.ipDispositivo = other.ipDispositivo;
      this.ipDispositivo = other.ipDispositivo;
      this.documento = other.documento;
      this.nome = other.nome;
    }
  }

  get asForm(): FormGroup {
    if (this.form == null) {
      this.form = new FormGroup({
        parceiroId: new FormControl(this.parceiroId, [Validators.required]),
        declaroSerRepresentanteLegal: new FormControl(this.declaroSerRepresentanteLegal, [Validators.required, Validators.requiredTrue]),
        tipoTermo: new FormControl(this.tipoTermo, [Validators.required]),
        ipDispositivo: new FormControl(this.ipDispositivo, [Validators.required]),
        nome: new FormControl(this.nome, [Validators.required]),
        documento: new FormControl(this.documento, [Validators.required, this.validarDocumento()])
      });
    }
    return this.form;
  }

  validarDocumento() {
    return (control: AbstractControl): Validators => {
      const cpf = control.value;
      if (cpf) {
        let numeros, digitos, soma, i, resutado, digitosIguais;
        digitosIguais = 1;
        if (cpf.length > 11) {
          if(this.isValidCnpj(cpf)) {
            return null;
          } else {
            return {documentoInvalido: true};
          }
        }

        for (i = 0; i < cpf.length - 1; i++) {
          if (cpf.charAt(i) !== cpf.charAt(i + 1)) {
            digitosIguais = 0;
            break;
          }
        }

        if (!digitosIguais) {
          numeros = cpf.substring(0, 9);
          digitos = cpf.substring(9);
          soma = 0;
          for (i = 10; i > 1; i--) {
            soma += numeros.charAt(10 - i) * i;
          }

          resutado = soma % 11 < 2 ? 0 : 11 - (soma % 11);

          if (resutado !== Number(digitos.charAt(0))) {
            return {documentoInvalido: true};
          }
          numeros = cpf.substring(0, 10);
          soma = 0;

          for (i = 11; i > 1; i--) {
            soma += numeros.charAt(11 - i) * i;
          }
          resutado = soma % 11 < 2 ? 0 : 11 - (soma % 11);

          if (resutado !== Number(digitos.charAt(1))) {
            return {documentoInvalido: true};
          }
          return null;
        } else {
          return {documentoInvalido: true};
        }
      }
      return null;
    };
  }
  isValidCnpj(cnpj: string): boolean {
    cnpj = cnpj.replace(/[^\d]+/g, '');
    if (cnpj.length !== 14) {
      return false;
    }

    if (/^(\d)\1+$/.test(cnpj)) {
      return false;
    }

    let soma = 0;
    let fator = 5;
    for (let i = 0; i < 12; i++) {
      soma += parseInt(cnpj.charAt(i)) * fator;
      fator = fator === 2 ? 9 : fator - 1;
    }

    let restante = soma % 11;
    let digito = restante < 2 ? 0 : 11 - restante;

    if (parseInt(cnpj.charAt(12)) !== digito) {
      return false;
    }

    soma = 0;
    fator = 6;
    for (let i = 0; i < 13; i++) {
      soma += parseInt(cnpj.charAt(i)) * fator;
      fator = fator === 2 ? 9 : fator - 1;
    }

    restante = soma % 11;
    digito = restante < 2 ? 0 : 11 - restante;

    if (parseInt(cnpj.charAt(13)) !== digito) {
      return false;
    }

    return true;
  }

}
